// import MainLayout from 'layout/MainLayout';
// import MinimalLayout from 'layout/MinimalLayout';
// import HeaderLayout from 'layout/HeaderLayout';
import React from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports

// import { Test } from 'views/admin-components/pages/Test';
// import LandingTestPage from 'views/user-components/LandingTestPage';
// import Home from 'views/user-components/pages/dashboard/Home';
// import ProfileFinalStep from 'views/user-components/pages/signup-profile/ProfileFinalStep';


import Loadable from 'ui-component/Loadable';

// const ProfileSteps = Loadable(lazy(() => import('views/user-components/pages/signup-profile/ProfileSteps')));
// const Test = Loadable(lazy(() => import('views/admin-components/pages/Test')));
const DashBoardLayout = Loadable(lazy(() => import('layout/DashboardLayout')));
const Home = Loadable(lazy(() => import('views/user-components/pages/dashboard/Home')));
const AssetAllocation = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocation')));
const AssetAllocationHome = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocationMain')));
const EmployeeInfo = Loadable(lazy(() => import('views/user-components/pages/dashboard/EmployeeInfo')));
const MessageCenter = Loadable(lazy(() => import('views/user-components/pages/dashboard/MessageCenter')));
// const Personal = Loadable(lazy(() => import('views/user-components/pages/dashboard/Personal')));
const Goals = Loadable(lazy(() => import('views/user-components/pages/dashboard/Goals')));
const Accounts = Loadable(lazy(() => import('views/user-components/pages/dashboard/Accounts')));
const Assets = Loadable(lazy(() => import('views/user-components/pages/dashboard/Assets')));
const IncomeExpenses = Loadable(lazy(() => import('views/user-components/pages/dashboard/IncomeExpenses')));
const EstatePlanning = Loadable(lazy(() => import('views/user-components/pages/dashboard/EstatePlanning')));
const Fees = Loadable(lazy(() => import('views/user-components/pages/dashboard/Fees')));
const AssetAllocationAccounts = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocationAccounts')));

const AccountSummary = Loadable(lazy(() => import('views/user-components/pages/dashboard/AccountSummary')));
const CashFlow = Loadable(lazy(() => import('views/user-components/pages/dashboard/CashFlow')));
const NetWorth = Loadable(lazy(() => import('views/user-components/pages/dashboard/NetWorth')));
const FundTransfer = Loadable(lazy(() => import('views/user-components/pages/dashboard/FundTransfer')));
const DataVault = Loadable(lazy(() => import('views/user-components/pages/dashboard/DataVault')));
const AssetDrift = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetDrift')));
const ProjectedCashFlow = Loadable(lazy(() => import('views/user-components/pages/dashboard/ProjectedCashFlow')));
const ProjectedNetWorth = Loadable(lazy(() => import('views/user-components/pages/dashboard/ProjectedNetWorth')));
const InsuranceCalculator = Loadable(lazy(() => import('views/user-components/pages/dashboard/InsuranceCalculator')));
const FinancialGoal = Loadable(lazy(() => import('views/user-components/pages/dashboard/FinancialGoal')));
// const ThankYouPage = Loadable(lazy(() => import('views/admin-components/pages/admin-client-form/ThankYouPage')));


const NotFound = () => <div>Page Not Found</div>;

const DashboardRouteGuard = ({ children }) => {
    const loginType = localStorage.getItem('login_type');
    const dashboardLogin = localStorage.getItem('dashboard_login');
    const isDashboardLogin =
        (loginType === 'portfolio_manager' || loginType === 'dashboard_admin' || loginType === 'client') &&
        dashboardLogin === 'true';

    return isDashboardLogin ? children : <Navigate to="/" />;
};

const ClientRoutes = {
    path: '/',
    element: (
        <DashboardRouteGuard>
            <DashBoardLayout />
        </DashboardRouteGuard>
    ),
    children: [
        { path: '/home', element: <Home /> },
        { path: '/employee_info', element: <EmployeeInfo /> },
        // { path: '/personal', element: <Personal /> },
        { path: '/assetallocation', element: <AssetAllocation /> },
        { path: '/main', element: <AssetAllocationHome /> },
        { path: '/asset_allocation_accounts', element: <AssetAllocationAccounts /> },
        { path: '/goals', element: <Goals /> },
        { path: '/accounts', element: <Accounts /> },
        { path: '/assets', element: <Assets /> },
        { path: '/fees', element: <Fees /> },
        { path: '/fund-transfer', element: <FundTransfer /> },
        { path: '/income_expenses', element: <IncomeExpenses /> },
        { path: '/estate_planning', element: <EstatePlanning /> },
        // REPORT
        { path: '/account_summary', element: <AccountSummary /> },
        { path: '/cashflow', element: <CashFlow /> },
        { path: '/networth', element: <NetWorth /> },
        { path: '/data_vault', element: <DataVault /> },
        { path: '/message_center', element: <MessageCenter /> },
        { path: '/asset_drift', element: <AssetDrift /> },
        // FINANCIAL PLAN
        { path: '/projected_cash_flow', element: <ProjectedCashFlow /> },
        { path: '/projected_net_worth', element: <ProjectedNetWorth /> },
        { path: '/insurance_calculator', element: <InsuranceCalculator /> },
        { path: '/financial_goals', element: <FinancialGoal /> },
        // { path: '/thanks', element: <ThankYouPage /> },
        { path: '*', element: <NotFound /> },
    ]
};

export default ClientRoutes;
